// extracted by mini-css-extract-plugin
module.exports = {"section":"OfferTypes_section__21MOW","offerTypes":"OfferTypes_offerTypes__los2A","title":"OfferTypes_title__l7uDG","offer":"OfferTypes_offer__ZKnvg"};